'use client';

import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { catalogFrom, type Book, type BookCatalog, type BookId } from '@sharpr/types';

const EMPTY: BookCatalog = new Map();
const BookCatalogContext = createContext<BookCatalog>(EMPTY);

export function BookCatalogProvider({ books, children }: { books: readonly Book[] | null; children: ReactNode }) {
  const catalog = useMemo(() => (books ? catalogFrom(books) : EMPTY), [books]);
  return <BookCatalogContext.Provider value={catalog}>{children}</BookCatalogContext.Provider>;
}

export function useBookCatalogContext(): BookCatalog {
  return useContext(BookCatalogContext);
}

export function useBook(id: BookId): { id: BookId; name: string; book?: Book } {
  const book = useContext(BookCatalogContext).get(id);
  return { id, name: book?.name ?? id, book };
}
